import { combineReducers } from 'redux';

import acceptAgreementDataReducer from './acceptAgreementDataReducer';
import acceptAgreementUiReducer from './acceptAgreementUiReducer';

export default combineReducers({
  data: acceptAgreementDataReducer,
  ui: acceptAgreementUiReducer,
});
